import React from 'react'
import { getImage } from "../utils/common";

const LoadingSpinner = (props) => (
  <div className={`col-sm-12 text-center ${props?.showLoader ? '' : 'd-none'}`}>
    <img src={getImage('/preloader.gif')} alt="Loading..."/>
  </div>
)
export default LoadingSpinner;
